import { UserObjectType } from 'constants/graphqlTypes';

export const getTitle = (user: UserObjectType): string => {
  const name = user.userInfo?.firstName ?? user.username;

  return `A response to ${name}`;
};
